/**
 * Svensk title block per A3/A4-konvention (SS-EN ISO 7200 andemening).
 * Position:fixed nere till höger via print.css; osynlig på skärm (print-only).
 */
export type TitleBlockProps = {
  projectName?: string;
  projectNumber?: string;
  clientName?: string;
  documentName?: string;
  drawingNumber?: string;
  scale?: string;
  date?: string;
  designer?: string;
  companyName?: string;
  revision?: string;
};

export function TitleBlock(props: TitleBlockProps) {
  const today = new Date().toISOString().slice(0, 10);
  const {
    projectName = "—",
    projectNumber = "—",
    clientName = "—",
    documentName = "—",
    drawingNumber = "1/1",
    scale = "Utan skala",
    date = today,
    designer = "—",
    companyName = "Electro Planner",
    revision = "A",
  } = props;

  return (
    <div className="print-only print-title-block">
      <table>
        <tbody>
          <tr>
            <th>Företag</th>
            <td colSpan={3} className="title-block-company">
              {companyName}
            </td>
          </tr>
          <tr>
            <th>Uppdrag</th>
            <td>{projectName}</td>
            <th>Uppdrags&shy;nr</th>
            <td>{projectNumber}</td>
          </tr>
          <tr>
            <th>Beställare</th>
            <td colSpan={3}>{clientName}</td>
          </tr>
          <tr>
            <th>Ritning</th>
            <td colSpan={3}>{documentName}</td>
          </tr>
          <tr>
            <th>Konstruktör</th>
            <td>{designer}</td>
            <th>Datum</th>
            <td>{date}</td>
          </tr>
          <tr>
            <th>Skala</th>
            <td>{scale}</td>
            <th>Rev</th>
            <td>{revision}</td>
          </tr>
          <tr>
            <th>Ritn.nr</th>
            <td colSpan={3}>{drawingNumber}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
